<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";

import Video from '@/components/standard/PromotionPrevention/components/Video'

/**
 * Form elements component
 */
export default {
  page: {
    title: "Capacitaciones del SGSST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Video,
  },
  data() {
    return {
      title: "Capacitaciones del SGSST",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: '1.2.1 Listado de Programas de Capacitación Promoción y Prevención',
        href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/promocion-prevencion`,
      },   
      {
        text: 'Capacitaciones del SGSST ',
        active: true,
      },
      ],

      selected: {
        id: 0,
        description: "PROMOCIÓN Y PREVENCIÓN"
      },

      options: [
        {
          id: 0,
          description: "PROMOCIÓN Y PREVENCIÓN"
        },
        {
          id: 1,
          description: "BIOLÓGICO"
        },
        {
          id: 2,
          description: "FÍSICO"
        },
        {
          id: 3,
          description: "QUÍMICO"
        },
        {
          id: 4,
          description: "PSICOSOCIAL"
        },
        {
          id: 5,
          description: "ERGONÓMICO"
        },
        {
          id: 6,
          description: "MECÁNICO"
        },
        {
          id: 7,
          description: "AMBIENTAL"
        },
      ]

    };
  },
  methods: {

    goBack() {
      this.$router.go(-1);
    }

  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="card">

          <div class="card-body">

            <div>
              <div class="row">

                <div class="col-md-12 pt-0 text-right" @click="goBack">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left">
                    Volver
                  </b-tooltip>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-12 text-center pr-2">

                  <div class="row text-center ml-5">

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210" src="https://www.youtube.com/embed/y3y7Dw1LeBw"
                        title="Promoción y Prevención." frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210" src="https://www.youtube.com/embed/WObAJXqKgj8"
                        title="¿Qué es riesgo Biológico? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/IlSlsUiLYVc"
                        title="¿Qué es riesgo físico? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/AgL05yi-3ZQ"
                        title="¿Qué es Riesgo Químico? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/KsawTwkefgI"
                        title="¿Qué es Riesgo Psicosocial? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/ApzYwN3dCmc"
                        title="¿Qué es Riesgo Ergonómico? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/swKTS0uQ_D8"
                        title="¿Qué es Riesgo Mecánico? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                    <div class="col-sm-12 col-md-5 col-lg-5 m-2 p-0">
                      <iframe width="320" height="210"  src="https://www.youtube.com/embed/6VJnnUHfNmw"
                        title="¿Qué es Riesgo Ambiental? SST" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>





  </Layout>
</template>
